// breadcrumbMap.js
export const breadcrumbMap = {
  QuestionsView: [
    { title: 'Home', view: 'HomeView', isBold: true },
    { title: 'Accesso per le Stazioni Appaltanti', view: 'StazioniAppaltantiView', isBold: true },
    { title: 'Accedi al servizio', view: 'AccediServizioView', isBold: true },
    { title: 'Elenco Quesiti', view: 'QuestionsView', isBold: true }
  ],
  QuestionView: [
    { title: 'Home', view: 'HomeView', isBold: true },
    { title: 'Accesso per le Stazioni Appaltanti', view: 'StazioniAppaltantiView', isBold: true },
    { title: 'Accedi al servizio', view: 'AccediServizioView', isBold: true },
    { title: 'Nuovo Quesito', view: 'QuestionView', isBold: true }
  ],
  UserDetailView: [
    { title: 'Home', view: 'HomeView', isBold: true },
    { title: 'Accesso per le Stazioni Appaltanti', view: 'StazioniAppaltantiView', isBold: true },
    { title: 'Accedi al servizio', view: 'AccediServizioView', isBold: true },
    { title: 'Dati Anagrafici', view: 'UserDetailView', isBold: true }
  ],
    ArticlesView: [
    { title: 'Home', view: 'HomeView', isBold: true },
    { title: 'Accesso per le Stazioni Appaltanti', view: 'StazioniAppaltantiView', isBold: true },
    { title: 'Accedi al servizio', view: 'AccediServizioView', isBold: true },
    { title: 'Nuovo Quesito', view: 'ArticlesView', isBold: true }
  ],
    ArticleView: [
    { title: 'Home', view: 'HomeView', isBold: true },
    { title: 'Accesso per le Stazioni Appaltanti', view: 'StazioniAppaltantiView', isBold: true },
    { title: 'Accedi al servizio', view: 'AccediServizioView', isBold: true },
    { title: 'Modulo per invio quesiti', view: 'ArticleView', isBold: true }
  ],
    QuestionsByTopicView: [
    { title: 'Home', view: 'HomeView', isBold: true },
    { title: 'Accesso per le Stazioni Appaltanti', view: 'StazioniAppaltantiView', isBold: true },
    { title: 'Accedi al servizio', view: 'AccediServizioView', isBold: true },
    { title: 'Nuovo Quesito', view: 'ArticlesView', isBold: true }
  ]
};
